export default function hasReferencesStrUtil (str) {
  return /references?:/gi.test(str)
}
